import { Constants } from "@/services/Constants";

export function standardizeErrorMsg(errorMsg: string, appendErrMsg: string): any {
    errorMsg = errorMsg ? errorMsg + Constants.strReturnLine + appendErrMsg : appendErrMsg;
    return errorMsg;
  }